import { motion } from "framer-motion";
import { ArrowLeft, Download, CheckCircle2, AlertTriangle, FileSpreadsheet, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { exportToExcel, exportToPdf } from "./exportHandlers";

export function ResultsHeader({ consulta, results, id, i18n, exportingPdf, setExportingPdf, navigate }) {
  const { t } = useTranslation();

  return (
    <>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-8">
        <div>
          <Button variant="ghost" onClick={() => navigate(`/consultes/${id}`)} className="mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />{t('common.back')}
          </Button>
          <h1 className="text-3xl font-heading font-bold text-slate-900">{t('results.title')}</h1>
          <p className="text-slate-500 mt-1">{consulta?.title}</p>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" data-testid="export-btn" disabled={exportingPdf}>
              <Download className="h-4 w-4 mr-2" />{t('results.export')}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => exportToExcel(consulta, results, i18n, t)} data-testid="export-excel">
              <FileSpreadsheet className="h-4 w-4 mr-2" />Excel (.xlsx)
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => exportToPdf(id, consulta, t, setExportingPdf)} data-testid="export-pdf">
              <FileText className="h-4 w-4 mr-2" />PDF
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className={`rounded-lg p-4 mb-6 flex items-center gap-3 ${
          results?.integrity_ok ? "bg-emerald-50 border border-emerald-200" : "bg-red-50 border border-red-200"
        }`}>
        {results?.integrity_ok
          ? <CheckCircle2 className="h-5 w-5 text-emerald-600" />
          : <AlertTriangle className="h-5 w-5 text-red-600" />}
        <span className={results?.integrity_ok ? "text-emerald-800" : "text-red-800"}>
          {results?.integrity_ok ? t('results.allVotesVerified') : t('results.integrityIssues')}
        </span>
      </motion.div>
    </>
  );
}
